/*
  Default Config Settings

  Can be configured through: `window.$candy` dictionary.
*/
import pjson from '../../package.json'

const Settings = () => {
  const defaultSettings = {
    'apiHost': 'http://localhost:8000',
    'name': 'isabl',
    'logo': 'https://user-images.githubusercontent.com/7906289/45718714-09330200-bb6c-11e8-8a60-5da580086a5f.png'
  }
  const settings = {}
  Object.entries(defaultSettings).forEach(([field, defaultValue]) => {
    settings[field] = (window.$candy && window.$candy[field]) || defaultValue
  })
  return {
    ...settings,
    endpoints: endpoints(settings.apiHost),
    fixedLogo: defaultSettings.logo,
    version: pjson.version
  }
}

const endpoints = (host) => {
  let apiNamespace = 'api/v1'
  let authNamespace = `${apiNamespace}/rest-auth`

  return {
    // authentication
    login: `${host}/${authNamespace}/login/`,
    signup: `${host}/${authNamespace}/registration/`,
    user: `${host}/${authNamespace}/user/`,
    password: `${host}/${authNamespace}/password/`,
    // models
    aliquots: `${host}/${apiNamespace}/aliquots`,
    analyses: `${host}/${apiNamespace}/analyses`,
    extractions: `${host}/${apiNamespace}/extractions`,
    individuals: `${host}/${apiNamespace}/individuals`,
    projects: `${host}/${apiNamespace}/projects`,
    samples: `${host}/${apiNamespace}/samples`,
    submissions: `${host}/${apiNamespace}/submissions`,
    tags: `${host}/${apiNamespace}/tags`,
    users: `${host}/${apiNamespace}/users`,
    experiments: `${host}/${apiNamespace}/experiments`
  }
}

export default Settings
